import { EnumMyleLoginPermission } from "../Models/EnumMyleLoginPermission";

interface IPermissionGateProps {
    children: React.ReactNode;
    requiredPermission: EnumMyleLoginPermission;
    bypassRestriction?: boolean;
}

function PermissionGate({ children, requiredPermission, bypassRestriction }: IPermissionGateProps): JSX.Element | null {
    if (!bypassRestriction && !sessionStore.hasPermission(requiredPermission)) {
        return null;
    }

    return <>{children}</>;
}

export { PermissionGate };
